import domReady from '@wordpress/dom-ready';
import Mmenu from 'mmenu-js';
import 'mburger-webcomponent';

import { doOnParents } from './util';
import { initHoverable } from './hoverable';
import { initSticky } from './sticky';
import { initMobileSearch } from './mobile';

// @ts-ignore
import( 'mmenu-js/dist/mmenu.css' );

const menuConfig = {
	classNames: {
		selected: 'active',
	},
	navbars: [
		{
			position: 'top',
			content: [ 'prev', 'title', 'close' ],
		},
	],
};

const menuOptions = {
	offCanvas: {
		page: {
			selector: '#page',
		},
	},
};

function initPrimaryMenu( menu: HTMLElement ) {
	initHoverable( {
		root: menu,
		hoverableSelector: '.menu-item',
		displaySelector: '> .sub-menu',
	} );
}

function initUserDropdown( userDropdown: HTMLElement ) {
	// When userDropdown is clicked, add 'show' class to a child element identified by ".user-dropdown__items", and to the wrapper
	const toggleButton = userDropdown.querySelector(
		':scope > .user-link'
	) as HTMLElement;
	const dropdownItems = userDropdown.querySelector(
		':scope .user-dropdown__items'
	) as HTMLElement;
	toggleButton.addEventListener( 'click', ( e: MouseEvent ) => {
		e.preventDefault();
		dropdownItems.classList.toggle( 'show' );
		userDropdown.classList.toggle( 'items-showing' );
	} );
	document.addEventListener( 'click', ( e ) => {
		// When clicked outside, hide user dropdown
		if ( ! e.composedPath().includes( userDropdown ) ) {
			dropdownItems.classList.remove( 'show' );
			userDropdown.classList.remove( 'items-showing' );
		}
	} );
}

function initUserMenu( menu: HTMLElement ) {
	const submenus = Array.from(
		menu.querySelectorAll( ':scope .ab-sub-wrapper' )
	);

	initHoverable( {
		root: menu,
		hoverableSelector: '.menupop',
		displaySelector: '> .ab-sub-wrapper',
	} );

	// Whenever menu resizes, recompute "top" values for submenus so that they are aligned
	// with main list items.
	const setTop = ( rootY ) => ( submenu ) => {
		const parent = submenu.closest( '.menupop' ) as HTMLElement;
		const { top } = parent.getBoundingClientRect();
		submenu.style.top = `${ top - rootY }px`;
	};

	const updateSubmenus = () => {
		const { top } = menu.getBoundingClientRect();
		submenus.forEach( setTop( top ) );
	};

	updateSubmenus();

	const observer = new ResizeObserver( ( entries ) => {
		for ( const entry of entries ) {
			updateSubmenus();
		}
	} );

	observer.observe( menu );

	menu.addEventListener( 'scroll', () => {
		updateSubmenus();
	} );
}

function initMobileMenu() {
	const menu = new Mmenu(
		'#gma-mobile-menu-wrapper',
		menuConfig,
		menuOptions
	);
	hideAdminBarWhenMenuOpened( menu );
}

function hideAdminBarWhenMenuOpened( menu: Mmenu ) {
	const adminBar = document.getElementById( 'wpadminbar' );
	menu.API.bind( 'open:before', () => {
		if ( adminBar ) {
			adminBar.style.display = 'none';
		}
	} );
	menu.API.bind( 'close:after', () => {
		if ( adminBar ) {
			adminBar.style.removeProperty( 'display' );
		}
	} );
}

function initMobileUserDropdown() {
	const menuElement = document.getElementById( 'gma-user-dropdown-mobile' );
	if ( ! menuElement ) {
		return;
	}
	const menu = new Mmenu(
		'#gma-user-dropdown-mobile',
		menuConfig,
		menuOptions
	);
	const toggle = document.getElementById(
		'gma-user-dropdown-mobile-sdebat8'
	) as HTMLElement;
	hideAdminBarWhenMenuOpened( menu );
	toggle.addEventListener( 'click', () => {
		const isOpen = menuElement.classList.contains( 'mm-menu--opened' );
		if ( isOpen ) {
			menu.API.close();
		} else {
			menu.API.open();
		}
	} );
}

domReady( () => {
	// Desktop
	const primaryMenu = document.getElementById(
		'gma-primary-menu'
	) as HTMLElement;
	initPrimaryMenu( primaryMenu );

	initMobileMenu();
	initMobileUserDropdown();
	initMobileSearch();

	const userDropdown = document.getElementById( 'gma-user-dropdown' );
	if ( userDropdown ) {
		initUserDropdown( userDropdown );
	}

	const userMenu = document.getElementById( 'gma-user-dropdown-items' );

	if ( userMenu ) {
		initUserMenu( userMenu );
	}

	initSticky();

	document.body.classList.add( 'gma-header-loaded' );
} );
